// Custom: https://github.com/bachdgvn/vue-otp-input
<template>
  <div style="display: flex; align-items: center">
    <!-- min="0"
      pattern="[0-9]"
      max="9" -->
    <input
      ref="input"
      v-model="model"
      :type="inputType"
      :inputmode="inputMode"
      :maxlength="inputLength"
      :class="inputClasses"
      :disabled="disabled"
      @input="handleOnChange"
      @keydown="handleOnKeyDown"
      @paste="handleOnPaste"
      @focus="handleOnFocus"
      @blur="handleOnBlur"
    />
    <span
      v-if="!isLastChild && separator"
      style="margin: 0 4px; color: rgb(216, 222, 229)"
      v-html="separator"
    />
  </div>
</template>

<script>
import { paddingZero } from '@/utils/dataHandler'

export default {
  name: 'SingleOtpInput',
  props: {
    value: {
      type: String
    }, // value that parent pass to child
    separator: {
      type: String
    },
    inputClasses: {
      type: String
    },
    focus: {
      type: Boolean
    },
    shouldAutoFocus: {
      type: Boolean
    },
    inputLength: {
      type: Number,
      default: 4
    },
    inputType: {
      type: String,
      default() {
        return 'tel'
      }
    },
    inputMode: {
      type: String,
      default() {
        return 'text'
      }
    },
    isLastChild: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value || ''
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.model = newValue
      }
    },
    // whenever question changes, this function will run
    focus(newFocusValue, oldFocusValue) {
      // Check if focusedInput changed
      // Prevent calling function if input already in focus
      if (oldFocusValue !== newFocusValue && this.$refs.input && this.focus) {
        this.$refs.input.focus()
        // this.$refs.input.select();
      }
    }
  },
  mounted() {
    if (this.$refs.input && this.focus && this.shouldAutoFocus) {
      this.$refs.input.focus()
    }
  },
  methods: {
    // util helper
    isCodeNumeric(charCode) {
      // numeric keys and numpad keys
      return (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 96 && charCode <= 105)
      )
    },

    // only emit if complete
    handleOnChange() {
      if (this.model.length === this.inputLength) {
        return this.$emit('on-change', this.model)
      }
    },
    // Only allow characters 0-9, DEL - 46, Backspace - 8, Enter - 13, Right and Left Arrows, and Pasting CTRL+V - 86
    handleOnKeyDown(event) {
      const keyEvent = event || window.event
      const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode
      if (
        this.isCodeNumeric(charCode) ||
        [8, 13, 37, 39, 46, 86].includes(charCode)
      ) {
        this.$emit('on-keydown', event)
      } else {
        keyEvent.preventDefault()
      }
    },
    // not used
    handleOnPaste(event) {
      return this.$emit('on-paste', event)
    },
    handleOnFocus() {
      this.$refs.input.select()
      return this.$emit('on-focus')
    },
    // blur when input is not complete! => padding zero before
    handleOnBlur() {
      if (
        this.inputLength === 2 &&
        this.model?.length < this.inputLength &&
        this.model.length > 0
      ) {
        this.model = paddingZero(this.model, 'D')
        this.$emit('on-change', this.model)
      }
      if (
        this.inputLength === 4 &&
        this.model?.length < this.inputLength &&
        this.model.length > 0
      ) {
        this.model = paddingZero(this.model, 'y')
        this.$emit('on-change', this.model)
      }
      return this.$emit('on-blur')
    }
  }
}
</script>

<style lang="scss" scoped>
div[class*='-input'] {
  // margin-left: 4px;
  .otp-input {
    border: none;
    border-bottom: 1px solid rgb(216, 222, 229);
    border-radius: 0;
    padding: 0;
    height: 20px;
    line-height: 25px;
    background-color: #f0f0f5;
    font-size: 14px;

    :disabled {
      background-color: #f5f7fa !important;
    }
  }

  &.date-input,
  &.month-input,
  &.hour-input,
  &.minute-input {
    .otp-input {
      width: 16px;
    }
  }

  &.year-input {
    .otp-input {
      width: 32px;
    }
  }

  &.hour-input {
    margin-left: 1rem;
  }
}
</style>
